import React from 'react';

import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';

export const LoadingContainer = ({ children }: React.PropsWithChildren) =>
  React.createElement(Box, { style: styles.container }, children);

const styles = StyleSheet.create({
  container: { alignItems: 'center', height: 24, justifyContent: 'center', width: 24 },
});
